module.exports = __webpack_public_path__ + "img/Logo_cortada.4014ed38.png";